import { useEffect } from "react";
import "@/campus.css";

function App() {
  useEffect(() => {
    window.REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
    if (document.getElementById("campus-engine-script")) return;
    const s = document.createElement("script");
    s.id = "campus-engine-script";
    s.src = `${process.env.PUBLIC_URL || ""}/campus-engine.js`;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return <div id="app" data-testid="campus-root" />;
}

export default App;
